import { render } from "./AddStudent.vue?vue&type=template&id=452e9df2&scoped=true"
import script from "./AddStudent.vue?vue&type=script&lang=js"
export * from "./AddStudent.vue?vue&type=script&lang=js"

import "./AddStudent.vue?vue&type=style&index=0&id=452e9df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452e9df2"]])

export default __exports__